import React, { useEffect, useState } from 'react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

export default function UpdateNotifier() {
  const [waitingRegistration, setWaitingRegistration] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        setWaitingRegistration(registration);
        setVisible(true);
      }
    });

    // Listen for controller change to reload the page when new SW takes over
    const onControllerChange = () => {
      window.location.reload();
    };
    navigator.serviceWorker && navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);

    return () => {
      navigator.serviceWorker && navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
    };
  }, []);

  const updateApp = () => {
    if (!waitingRegistration) return;
    serviceWorkerRegistration.promptSkipWaiting(waitingRegistration);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-white shadow-lg rounded-lg p-4 border border-gray-200 z-50">
      <div className="flex items-center space-x-4">
        <div className="flex-1">Hay una nueva versión disponible.</div>
        <button
          className="bg-blue-600 text-white px-3 py-1 rounded"
          onClick={updateApp}
        >
          Actualizar
        </button>
        <button
          className="text-sm text-gray-600 px-2"
          onClick={() => setVisible(false)}
        >
          Cerrar
        </button>
      </div>
    </div>
  );
}
